import { useState } from "preact/compat"
import { useAsyncEffect } from "@/utils"
import { IntegrationWithJobInfo, getIntegrationsWithJobs, findIntegrationByName } from "@/api/integration"
import { LoadingSpinner } from "@/app/loading"
import { Button } from "@/components/ui/button"
import { useLocation } from "wouter-preact"
import { SettingsLayout } from "@/settings/layout"
import { IntegrationSettingsLayout, SettingsSection } from "../layout"
import krogerLogo from "/img/integration/kroger.png"
import { SyncStatusDisplay } from "../sync-status-row"
import { KrogerProductReviewSection } from "./product_review"
import { UpdateCredentialsForm } from "../update-credentials-form"
import { ContractsList } from "@/contracts/contracts-list"
import { KrogerUploadSection } from "../kroger-upload-section"

export function KrogerSettingsPage() {
  const [, setLocation] = useLocation()
  const [krogerIntegration, setKrogerIntegration] = useState<IntegrationWithJobInfo | null>(null)
  const [loading, setLoading] = useState(true)

  async function refreshIntegration() {
    const res = await getIntegrationsWithJobs()
    if (res.ok) {
      const found = findIntegrationByName(res.value.data, "kroger")
      if (found) {
        setKrogerIntegration(found)
      }
    }
  }

  useAsyncEffect(async () => {
    await refreshIntegration()
    setLoading(false)
  }, [])

  if (loading) {
    return (
      <SettingsLayout>
        <div class="flex justify-center py-12">
          <LoadingSpinner />
        </div>
      </SettingsLayout>
    )
  }

  if (!krogerIntegration) {
    return (
      <SettingsLayout>
        <div class="text-center py-12">
          <p class="text-gray-500 mb-4">Kroger integration not found</p>
          <Button variant="outline" onClick={() => setLocation("/settings/connections")}>
            Back to Connections
          </Button>
        </div>
      </SettingsLayout>
    )
  }

  return (
    <IntegrationSettingsLayout
      logo={krogerLogo}
      name="Kroger"
      username={krogerIntegration.username}
      integrationId={krogerIntegration.id}>
      <SettingsSection title="Sync Status">
        <SyncStatusDisplay lastSyncJob={krogerIntegration.last_sync_job} integrationName="kroger" />
      </SettingsSection>

      <SettingsSection title="Upload PartnerPass exports">
        <KrogerUploadSection integrationId={krogerIntegration.id} onUploaded={refreshIntegration} />
      </SettingsSection>

      <SettingsSection title="Credentials">
        <p class="text-sm text-gray-500 mb-4">Update your PartnerPass login credentials.</p>
        <UpdateCredentialsForm
          integrationName="kroger"
          integrationId={krogerIntegration.id}
          initialUsername={krogerIntegration.username}
          credentialUpdatedAt={krogerIntegration.credential_updated_at}
        />
      </SettingsSection>

      <KrogerProductReviewSection />

      <SettingsSection title="Contract Documents">
        <ContractsList source="kroger" integrationId={krogerIntegration.id} />
      </SettingsSection>
    </IntegrationSettingsLayout>
  )
}
